import React from 'react';
import { Lock } from 'lucide-react';

const fmt = (n) => (n == null ? '—' : `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

// Staff-only garment cost / sell / profit view. Decoration COST is not tracked, so only decoration CHARGES are shown.
export const InternalPricingCard = ({ internal, compact }) => {
  if (!internal) return null;
  const rows = [
    ['Garment cost (wholesale)', fmt(internal.garment_cost_total), 'cost'],
    ['Garment selling price', fmt(internal.garment_sell_total), 'sell'],
    ['Est. garment gross profit', `${fmt(internal.garment_gross_profit)}${internal.garment_sell_total ? ` (${internal.garment_margin_pct}%)` : ''}`, 'profit'],
    ['Decoration charges', fmt(internal.decoration_charges), 'decoration'],
    ['Setup fees', fmt(internal.setup_fees), 'setup'],
    ['Decoration cost', 'not tracked', 'decoration-cost'],
  ];
  return (
    <div data-testid="internal-pricing-card" className={`mt-3 rounded-lg border border-amber-300 bg-amber-50 text-slate-800 ${compact ? 'p-3 text-xs' : 'p-4 text-sm'}`}>
      <div className="flex items-center gap-2 font-bold uppercase tracking-wide text-amber-800" style={{ fontSize: compact ? 11 : 12 }}><Lock size={12} /> Internal — not shown to customer · markup {internal.garment_markup}×</div>
      <dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1">
        {rows.map(([k, v, id]) => <React.Fragment key={id}><dt className="text-slate-600">{k}</dt><dd className="text-right font-semibold" data-testid={`internal-${id}`}>{v}</dd></React.Fragment>)}
      </dl>
      {internal.items_without_cost > 0 && <p className="mt-2 text-[11px] text-amber-800">{internal.items_without_cost} item(s) have no wholesale cost (custom-priced) — excluded from profit.</p>}
    </div>
  );
};
